import ZeebePropertiesProvider from './ZeebePropertiesProvider';

export default {
  __init__: [ 'zeebePropertiesProvider' ],
  zeebePropertiesProvider: [ 'type', ZeebePropertiesProvider ]
};